module.exports = __webpack_public_path__ + "static/media/mollie-connector.268f6087.png";